module.exports = __webpack_public_path__ + "static/media/notice.171367bd.png";